import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  GO_TO_ACTION_WITH_ISSUE: `${cleanedFilename(
    __filename,
  )}-go-to-action-with-issue`,
};
